import { useLocation } from 'react-router-dom';

import { Divider } from 'antd';

import PatientISI from '@/components/PatientProgramIntroduction/yimmugo';

const Yimmugo = () => {
  const { pathname } = useLocation();
  const isPatient = pathname.includes('patient_support');

  if (isPatient) {
    return <PatientISI />;
  }

  return (
    <div className="bg-[#f3f3f3] p-4 md:p-8 pt-4 rounded-md">
      <Divider />
      <p className="m-2">
        <b>INDICATIONS AND USAGE</b>
      </p>

      <p className="m-2">
        YIMMUGO® (immune globulin intravenous, human – dira) is a 10% immune globulin (Ig) liquid
        indicated for the treatment of primary humoral immunodeficiency in patients 2 years of age
        and older.
      </p>

      <p className="m-2 mt-6">
        <b>IMPORTANT SAFETY INFORMATION</b>
      </p>
      <div>
        <div className="solid text-md m-2 border border-[#000000] p-2 text-black">
          <p className="m-2">
            <b>WARNING: THROMBOSIS, RENAL DYSFUNCTION, and ACUTE RENAL FAILURE</b>
          </p>
          <ul className="list-disc ml-2">
            <li className="m-3">
              <b>Thrombosis may occur with Ig intravenous (IGIV) products, including YIMMUGO.</b>
            </li>
            <li className="m-3">
              <b>
                Renal dysfunction, acute renal failure, osmotic nephrosis, and death may occur with
                the administration of IGIV products in predisposed patients. Renal dysfunction and
                failure occur more commonly in patients receiving IGIV products containing sucrose.
                YIMMUGO does not contain sucrose.
              </b>
            </li>
            <li className="m-3">
              <b>
                For patients at risk of thrombosis, renal dysfunction, or renal failure, administer
                YIMMUGO at the minimum dose and infusion rate practicable. Ensure adequate hydration
                in patients before administration. Monitor for signs and symptoms of thrombosis and
                assess blood viscosity in patients at risk for hyperviscosity.
              </b>
            </li>
          </ul>
        </div>
        <p className="m-2 mt-6">
          <b>CONTRAINDICATIONS</b>
        </p>
        <p className="m-2">
          YIMMUGO is contraindicated in patients who have had an anaphylactic or severe systemic
          reaction to the administration of human Ig and in patients with immunoglobulin A (IgA)
          deficiency who have antibodies against IgA and a history of hypersensitivity.
        </p>

        <div className="space-y-3 mt-6">
          <p className="m-2">
            <b>WARNINGS AND PRECAUTIONS</b>
          </p>
          <p className="m-2">
            <b>Severe hypersensitivity reactions,</b> including anaphylaxis, have been reported
            after administration. In case of hypersensitivity, discontinue infusion immediately and
            institute appropriate treatment. YIMMUGO contains ≤300 mcg/mL of IgA. Patients with
            known antibodies to IgA may be at greater risk.
          </p>
          <p className="m-2">
            <b>Hemolysis</b> that is either intravascular or due to enhanced red blood cell
            sequestration can develop subsequent to IGIV treatment. Risk factors for hemolysis
            include high doses and non-O blood group. Monitor patients for hemolysis.
          </p>
          <p className="m-2">
            <b>Renal failure:</b> Monitor renal function, including blood urea nitrogen (BUN) and
            serum creatinine, and urine output in patients at risk of developing acute renal
            failure.
          </p>
          <p className="m-2 mt-3">
            <b>Hyperproteinemia, increased serum viscosity, and hyponatremia</b> may occur in
            patients receiving IGIV treatment, including YIMMUGO.
          </p>
          <p className="m-2">
            <b>Aseptic meningitis syndrome</b> may occur in patients receiving IGIV treatment,
            especially with high doses or rapid infusion.
          </p>
          <p className="m-2">
            <b>Transfusion-related acute lung injury:</b> Monitor patients for pulmonary adverse
            reactions.
          </p>
          <p className="m-2">
            <b>Transmissible infectious agents:</b> YIMMUGO is made from human plasma and may
            contain infectious agents, e.g., viruses and, theoretically, the Creutzfeldt-Jakob
            disease agent.
          </p>
          <p className="m-2">
            <b>Interference with laboratory tests:</b> After infusion of Ig, transitory rise of
            various passively transferred antibodies in the blood may yield positive serological
            results, with potential for misleading interpretation.
          </p>
        </div>
        <div className="mt-6 space-y-3">
          <p className="m-2 mt-6">
            <b>ADVERSE REACTIONS</b>
          </p>
          <p className="m-2">
            The most common adverse reactions occurring in ≥5% of patients were headache, upper
            respiratory tract infections, fatigue, nausea, and increased blood pressure.
          </p>
          <div>
            <p className="m-2">
              To report SUSPECTED ADVERSE REACTIONS, contact Kedrion Biopharma Inc. at 1-855-3KDRION
              (1-855-353-7466) or FDA at 1-800-FDA-1088 or
              <a target="_blank" href="http://www.fda.gov/medwatch" className="text-blue-500">
                &nbsp;www.fda.gov/medwatch.
              </a>
            </p>
            <p className="m-2">February 2025 YIM.0002.USA.25</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Yimmugo;
